import {StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {Tag} from 'folder-items/FileConstants';
import {BORDER_RADIUS_DEFAULT} from 'styles/StyleConstants';
import * as keyboard from 'util/Keyboard';
import {type TextAreaChangeEvent} from 'util/Types';

interface Props {
  autoFocus: boolean;
  defaultValue?: Tag;
  onChange: (e: {value: string}) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  isDisabled?: boolean;
}

export default function LongTextValueEditor(props: Props): JSX.Element {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>): void => {
    // forward to onKeyDown if available and it's not a shift enter (preserve default new line behavior)
    if (props.onKeyDown && !(e.shiftKey && keyboard.isEnterKey(e))) {
      props.onKeyDown(e);
    }
  };

  const handleOnChange = (e: TextAreaChangeEvent): void => {
    props.onChange({value: e.target.value});
  };

  const value = props.defaultValue?.value ?? '';
  return (
    <textarea
      autoFocus={props.autoFocus}
      className={classNames('metadata-tagValueTextArea', css(styles.textarea))}
      name="long_text_value"
      onFocus={(e) => {
        const input = e.target;
        input.setSelectionRange(0, input.value.length);
      }}
      onKeyDown={handleKeyDown}
      onChange={handleOnChange}
      placeholder={props.placeholder}
      rows={3}
      value={value}
      disabled={props.isDisabled}
    />
  );
}

const styles = StyleSheet.create({
  textarea: {
    borderRadius: BORDER_RADIUS_DEFAULT,
  },
});
